import { ISupplier } from 'contacts/types';
import { CorporatePartAssignVendorFormData } from 'corporate/components';
import { ICustomerQuotePart } from 'quotes/types';

export const getDefaultValues = (
  quotePart?: ICustomerQuotePart,
  isAlternateVersionEnabled = false
): Partial<CorporatePartAssignVendorFormData> => {
  if (!quotePart) {
    return isAlternateVersionEnabled ? { vendorLocation: null } : { vendor: null };
  }

  if (isAlternateVersionEnabled) {
    return {
      vendorLocation:
        quotePart.companyManufacturerName || quotePart.accountsPayableId
          ? {
              name: quotePart.companyManufacturerName,
              accountsPayableId: quotePart.accountsPayableId,
            }
          : null,
      vendorId: quotePart.companyManufacturerId,
      vendorName: quotePart.companyManufacturerName,
      accountsPayableId: quotePart.accountsPayableId,
    };
  }

  return {
    vendor: quotePart.companyManufacturerId
      ? {
          vendorName: quotePart.companyManufacturerName,
          vendorId: quotePart.companyManufacturerId,
        }
      : null,
    vendorName: quotePart.companyManufacturerName,
    vendorId: quotePart.companyManufacturerId,
  };
};

export const getExternalSupplier = (quotePart?: ICustomerQuotePart): Partial<ISupplier> => {
  if (!quotePart) {
    return null;
  }

  return {
    primaryContact: quotePart.supplier?.primaryContact,
    purchasingAttributes: quotePart.supplier?.purchasingAttributes,
  };
};
